export const CALCULATOR_ELEMENT = "calculator" as const;
